export const NEW_SIGN_IN_FLOW = "new_sign_in_flow"

export const NEW_SIGN_IN_FLOW_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}
